<template>
  <div>
    <div class="l-container">
      <p></p>
    </div>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  data () {
    return {
    }
  },
  methods: {
    getConditions (id) {
      this.$store.dispatch('getConditions', id)
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.getConditions(to.params.id)
    })
  },
  mounted () {
  },
  route: {
  }
}
</script>



// WEBPACK FOOTER //
// Conditions.vue?082f5636